<template>
    <div>
        <LabelTemplateToPrintDialog
            :is-open="labelToPrintTypeDialog"
            :template-type-ids="templateTypeIds"
            :selected-list-item-data="selectedListItem"
            :customer-id="customerId"
            @on-submit="saveLabelToPrintType"
            @on-close="closeLabelToPrintTypeDialog"
        />
        <v-dialog
            :value="isOpen"
            scrollable
            max-width="900px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onCLose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Drukowanie etykiet
                    </h1>
                </v-card-title>
                <v-card-text>
                    <v-checkbox
                        v-model="selectAllChecked"
                        :ripple="false"
                        label="Drukuj wszystkie"
                        class="mb-1"
                        hide-details
                        @change="selectAllTemplatesToPrint($event)"
                    />
                    <v-divider />
                    <v-expansion-panels
                        v-model="expandedPanels"
                        accordion
                        multiple
                    >
                        <v-expansion-panel
                            v-for="(shippingLabelPositionPackage, shippingLabelPositionPackageIndex) in templatesToPrint"
                            :key="shippingLabelPositionPackageIndex"
                        >
                            <v-expansion-panel-header>
                                <v-row no-gutters align="center" dense>
                                    <v-col cols="12" sm="1">
                                        <v-simple-checkbox
                                            v-model="shippingLabelPositionPackage.isSelected"
                                            :ripple="false"
                                            @input="selectShippingLabelPackage(shippingLabelPositionPackage, $event)"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        Nazwa: <strong>{{ shippingLabelPositionPackage.name }}</strong>
                                    </v-col>
                                    <v-col cols="12" sm="5">
                                        Szablon: <strong>{{ shippingLabelPositionPackage.templateName }}</strong>
                                    </v-col>
                                    <v-col v-if="!campaignPrint" cols="12" sm="2">
                                        <v-container fluid class="pa-0">
                                            <v-row justify="end" dense>
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            icon
                                                            data-sentry-label="Edycja etykiety"
                                                            v-on="on"
                                                            @click="showLabelToPrintTypeDialog(shippingLabelPositionPackage, $event)"
                                                        >
                                                            <v-icon color="blue">
                                                                mdi-pencil
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Edycja</span>
                                                </v-tooltip>
                                            </v-row>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>

                            <v-divider />

                            <!--  TOWARY -->
                            <v-expansion-panel-content v-if="shippingLabelPositionPackage.shippingOrderPositionPackageGoods.length > 0">
                                <v-row justify="end" dense>
                                    <v-col cols="12" sm="10">
                                        <v-row align="center">
                                            <v-col>
                                                <strong>Towary</strong>
                                                <v-row
                                                    v-for="(good, goodIndex) in shippingLabelPositionPackage.shippingOrderPositionPackageGoods"
                                                    :key="goodIndex"
                                                    no-gutters
                                                    align="center"
                                                    dense
                                                >
                                                    <v-col cols="12" sm="1">
                                                        <v-simple-checkbox
                                                            v-model="good.isSelected"
                                                            :disabled="isGoodDisabled(good)"
                                                            :ripple="false"
                                                            @input="updateTemplatesToPrint(good, $event)"
                                                        />
                                                    </v-col>
                                                    <v-col cols="12" sm="5" :class="{'text--disabled': isGoodDisabled(good)}">
                                                        Nazwa: <strong>{{ good.name }}</strong>
                                                    </v-col>
                                                    <v-col cols="12" sm="5" :class="{'text--disabled': isGoodDisabled(good)}">
                                                        Szablon: <strong>{{ good.templateName }}</strong>
                                                    </v-col>
                                                    <v-col v-if="!campaignPrint" cols="12" sm="1">
                                                        <v-container fluid class="pa-0">
                                                            <v-row justify="end" dense>
                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                    <template #activator="{on}">
                                                                        <v-btn
                                                                            icon
                                                                            data-sentry-label="Edycja etykiety"
                                                                            :disabled="isGoodDisabled(good)"
                                                                            v-on="on"
                                                                            @click="showLabelToPrintTypeDialog(good, $event)"
                                                                        >
                                                                            <v-icon color="blue">
                                                                                mdi-pencil
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Edycja</span>
                                                                </v-tooltip>
                                                            </v-row>
                                                        </v-container>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                            <!-- /TOWARY -->
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        data-sentry-label="Drukuj"
                        :loading="actionLoading"
                        :disabled="printShippingLabels.printShippingLabels.length == 0"
                        @click="printTemplateLabels()"
                    >
                        Drukuj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LabelTemplateToPrintDialog from './LabelTemplateToPrintDialog.vue'
import tooltipDelay from '@/mixins/tooltip'
import { openPdfFile } from '@/utils/pdfHandler'
import { errorHandler } from '@/utils/errorHandler'
import { orderBy } from 'lodash'

export default {
    name: 'PrintLabelTemplatesDialog',
    components: {
        LabelTemplateToPrintDialog
    },
    mixins: [
        tooltipDelay,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        templatesToPrintData: {
            type: Array,
            default: () => []
        },
        customerId: {
            type: Number,
            default: null
        },
        campaignPrint: {
            type: Boolean
        },
    },
    data() {
        return {
            expandedPanels: [],
            reportsSelectedToPrint: [],
            templatesToPrint: [],
            templateTypeIds: null,
            labelToPrintTypeDialog: false,
            selectedListItem: {},
            selectAllChecked: false,
            printShippingLabels: {
                printShippingLabels: []
            },
            actionLoading: false,
            printDialogHeaders: [
                {
                    text: 'Nazwa',
                    align: 'left',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Typ',
                    align: 'left',
                    sortable: false,
                    value: 'templateName'
                },
            ]
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.templatesToPrint = JSON.parse(JSON.stringify(this.templatesToPrintData))

                this.templatesToPrint.forEach((packageItem, packageIndex) => {
                    packageItem['packageIndex'] = packageIndex
                    packageItem['goodIndex'] = -1
                    packageItem.shippingOrderPositionPackageGoods.forEach((goodItem, goodIndex) => {
                        goodItem['goodIndex'] = goodIndex
                        goodItem['packageIndex'] = packageIndex
                    })
                })

                this.templatesToPrint.forEach((_, index) => {
                    this.expandedPanels.push(index)
                })
            } else {
                setTimeout(() => {
                    this.templatesToPrint = []
                    this.expandedPanels = []
                    this.reportsSelectedToPrint = []
                    this.templatesToPrint = []
                    this.templateTypeIds = null
                    this.labelToPrintTypeDialog = false
                    this.selectedListItem = {}
                    this.printShippingLabels.printShippingLabels = []
                    this.selectAllChecked = false
                }, 500)
            }
        }

    },
    methods: {
        isGoodDisabled(good) {
            return good.unitPackageType.id === 49 // pakowanie luzem
        },
        showLabelToPrintTypeDialog(selectedListItem, $event) {
            $event.stopPropagation()
            this.selectedListItem = selectedListItem
            this.labelToPrintTypeDialog = true
            this.templateTypeIds = selectedListItem.shippingLabelTemplateTypeId
        },
        saveLabelToPrintType(template) {
            this.selectedListItem.shippingLabelTemplateId = template.id
            this.selectedListItem.templateName = template.name
            this.selectedListItem.shippingLabelTemplateTypeId = [template.type]
            const index = this.templatesToPrint.findIndex(item => item.index === this.selectedListItem)

            this.templatesToPrint[index] = this.selectedListItem
            this.labelToPrintTypeDialog = false
        },
        closeLabelToPrintTypeDialog() {
            this.labelToPrintTypeDialog = false
        },
        selectAllTemplatesToPrint(value) {
            if (value) {
                this.templatesToPrint.map(packageItem => {
                    packageItem.shippingOrderPositionPackageGoods.map(good => {
                        if (good.unitPackageType.id === 49) {
                            return
                        }

                        good.isSelected = !good.checked
                        const goodIndex = this.printShippingLabels.printShippingLabels.findIndex(item =>
                            item.shippingLabelPositionPackageGoodId === good.shippingLabelPositionPackageGoodId)

                        if (goodIndex === -1) {
                            this.printShippingLabels.printShippingLabels.push(good)
                        }
                    })
                    packageItem.isSelected = !packageItem.checked

                    const packageIndex = this.printShippingLabels.printShippingLabels.findIndex(item =>
                        item.shippingLabelPositionPackageId === packageItem.shippingLabelPositionPackageId)

                    if (packageIndex === -1) {
                        this.printShippingLabels.printShippingLabels.push(packageItem)
                    }
                })
            } else {
                this.templatesToPrint.map(packageItem => {
                    packageItem.shippingOrderPositionPackageGoods.map(good => {
                        good.isSelected = false
                    })
                    packageItem.isSelected = false
                })
                this.printShippingLabels.printShippingLabels = []
                this.selectAllChecked = false
            }
        },
        selectShippingLabelPackage(packageItem, isChecked) {
            if (isChecked) {
                const packageGoodsToSelect = this.getAvailableGoodsToPrint(packageItem)

                this.printShippingLabels.printShippingLabels.push({
                    ...packageItem,
                    shippingOrderPositionPackageGoods: packageGoodsToSelect
                })
            } else {
                this.printShippingLabels.printShippingLabels.splice(
                    this.printShippingLabels.printShippingLabels.indexOf(packageItem.id),
                    1
                )
            }
        },
        updateTemplatesToPrint(good, value) {
            if (value) {
                this.printShippingLabels.printShippingLabels.push(good)
            } else {
                this.printShippingLabels.printShippingLabels.splice(this.printShippingLabels.printShippingLabels.indexOf(good.id), 1)
            }
        },
        getAvailableGoodsToPrint(packageItem) {
            return packageItem.shippingOrderPositionPackageGoods.filter(good => good.unitPackageType.id !== 49)
        },
        printTemplateLabels() {
            this.printShippingLabels.printShippingLabels = orderBy(this.printShippingLabels.printShippingLabels, ['packageIndex', 'goodIndex'], ['asc', 'asc'])

            this.actionLoading = true
            this.$store.dispatch('shipments/shipmentsLabels/printShippingLabel', this.printShippingLabels)
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.onClose()
                    this.actionLoading = false
                })
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.printShippingLabels.printShippingLabels = []
            }, 500)
        }
    }
}
</script>
